import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { InstitutionsAuthorizationGetRequestModel, InstitutionsAuthorizationGetResponseModel } from "@/features/accounts/shared/services/institutions-authorization-model";

export class InstitutionsAuthorizationApi {
  /**
   * 金融機関サイト認可画面要求
   */
  public getInstitutionsAuthorization = async (
    param: InstitutionsAuthorizationGetRequestModel
  ): Promise<InstitutionsAuthorizationGetResponseModel> => {
    const path = `/api/institutions/authorization`;
    const res = await ApiClient.instance.get<InstitutionsAuthorizationGetResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
